import { Loading } from '@ps/ds/icons/Loading'
import { cn } from '@ps/ds/lib/utils'

export const Spinner = ({ className, ...props }: React.ComponentProps<'svg'>) => {
  return (
    <Loading
      role="status"
      aria-label="Loading"
      className={cn('size-4 animate-spin', className)}
      strokeWidth={0.75}
      {...props}
    />
  )
}

Spinner.displayName = 'Spinner'
